export const buildOfferingWiseTableConfig = () => [
  {
    field: 'metrics',
    header: 'Metrics',
    defaultPinned: false,
    pinnable: false,
  },
  {
    field: 'target',
    header: 'Target',
    defaultPinned: false,
    pinnable: false,
    align: 'center',
    headerAlign: 'center',
    className: 'text-center-col',
    bodyClassName: 'text-center-col',
    headerClassName: 'text-center-col',
    style: { textAlign: 'center' },
    bodyStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    field: 'achieved',
    header: 'Achieved',
    defaultPinned: false,
    pinnable: false,
    align: 'center',
    headerAlign: 'center',
    className: 'text-center-col',
    bodyClassName: 'text-center-col',
    headerClassName: 'text-center-col',
    style: { textAlign: 'center' },
    bodyStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
];

const toOption = (option) => {
  if (option && typeof option === 'object') {
    const label = option.label ?? option.name ?? option.value ?? '';
    const value = option.value ?? option.id ?? label;

    return {
      label,
      value,
    };
  }

  return {
    label: option,
    value: option,
  };
};

const getFilterSource = (source) =>
  Array.isArray(source) ? { values: source } : source || {};

const resolveFilterSource = (filter) =>
  Array.isArray(filter) ? { values: filter } : filter || {};

const buildChoiceFilter = (field, label, source, template = 'choice') => {
  const { values = [], url } = getFilterSource(source);
  const options = values.map(toOption);

  return {
    type: 'filter',
    field,
    label,
    placeholder: `Select ${label}`,
    template,
    selectedValues: [],
    ...(url ? { url } : {}),
    options,
    values: options,
  };
};

const getFinancialYears = () => {
  const startYear = 2021;
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = startYear; year <= currentYear + 1; year++) {
    years.push(`${year}-${(year + 1).toString().slice(-2)}`);
  }
  return years;
};

export const createOfferingWiseFilters = (filterOptions = {}) => {
  return [
    {
      label: 'Offering',
      filter: buildChoiceFilter(
        'offeringIds',
        'Offering',
        {
          ...resolveFilterSource(filterOptions.offerings),
        },
        'multiSelect',
      ),
    },
    {
      label: 'Architect',
      filter: buildChoiceFilter(
        'architectId',
        'Architect',
        {
          ...resolveFilterSource(filterOptions.architects),
        },
        'singleSelect',
      ),
    },
    {
      label: 'Financial Year',
      filter: buildChoiceFilter(
        'financialYear',
        'Financial Year',
        {
          values: getFinancialYears(),
        },
        'singleSelect',
      ),
    },
  ];
};
